import { useSelector } from "react-redux";
export var useIsCurrentState = function (appState) {
    return useSelector(function (state) { return state.appReducer.currentState === appState; });
};
